import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'SlideTransition',
  props: {
    mode: { default: "out-in" },
    isVertical: { type: Boolean, default: false }
  },
  setup(__props: any) {



const name = computed(() => __props.isVertical ? "slide-vertical" : "slide-horizontal");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    mode: _ctx.mode,
    name: name.value
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["mode", "name"]))
}
}

})